import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

export interface Truck {
  Id?: number;
  TruckCode: string;
  TruckDescription: string;
  CubicFeet: number;
  StartDate: Date;
  EndDate?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class TruckService {

  // endpoints
  truckEp: string = `${this._apiSvc.endpoints.sales}/api/Truck`;

  constructor(
    private _apiSvc: ApiService
  ) { }

  /**
   * Search trucks
   * @param params 
   * @returns 
   */
  search(params: any): any {
    return this._apiSvc.search(this.truckEp, params)
      .pipe(
        map((res: any) => {
          return res.Data;
        })
      );
  }

  /**
   * Get truck 
   * @param id 
   * @returns 
   */
  get(id: number): any {
    return this._apiSvc.get(`${this.truckEp}/${id}`);
  }

  /**
   * Add truck
   * @param params 
   * @returns 
   */
  add(params: Truck): any {
    return this._apiSvc.add(this.truckEp, params);
  }

  /**
   * Update truck
   * @param params 
   * @returns 
   */
  update(params: Truck): any {
    return this._apiSvc.update(`${this.truckEp}/${params.Id}`, params);
  }

}
